const LONG = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "long", year: "numeric" });
const WITH_TIME = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

/** "20 September 2026". */
export function formatDate(iso: string): string {
  return LONG.format(new Date(iso));
}

/** "20 Sept 2026, 14:05". */
export function formatDateTime(iso: string): string {
  return WITH_TIME.format(new Date(iso));
}
